import { reportAPI } from '@/services-ts/axios'
import type {
  IDateRange,
  IGetAbuseReport,
  IGetCommentReport,
  IGetCommunityReport,
  IGetEmployeeGiftReport,
  IGetEngagementReport,
  IGetInternalTiesReport,
  IGetRewardReport,
} from '@/types/Request'
import { defineStore } from 'pinia'

export const useReportStore = defineStore('report', {
  actions: {
    async GetCommunityReport(payload: IGetCommunityReport) {
      const { data, status } = await reportAPI.ReportServices.GetCommunityReport(payload)
      return status ? data : []
    },

    async GetCommunityReportExcel(payload: IGetCommunityReport) {
      await reportAPI.ReportServices.GetCommunityReportExcel(payload)
    },

    async GetEmployeeRewardReport(payload: IGetRewardReport) {
      const response = await reportAPI.ReportServices.GetEmployeeRewardReport(payload)
      return response.status ? response : { data: [], total: 0 }
    },

    async GetEmployeeRewardReportExcel(payload: IDateRange) {
      await reportAPI.ReportServices.GetEmployeeRewardReportExcel(payload)
    },

    async GetEmployeeGiftReport(payload: IGetEmployeeGiftReport) {
      const { status, data } = await reportAPI.ReportServices.GetEmployeeGiftReport(payload)
      return status ? data : []
    },

    async GetEmployeeGiftReportExcel(payload: IDateRange) {
      await reportAPI.ReportServices.GetEmployeeGiftReportExcel(payload)
    },

    async GetPostReportByDivision(payload: IGetInternalTiesReport) {
      const { status, data } = await reportAPI.ReportServices.GetPostReportByDivision(payload)
      return status ? data : []
    },

    async GetPostReportByDivisionExcel(payload: IGetInternalTiesReport) {
      await reportAPI.ReportServices.GetPostReportByDivisionExcel(payload)
    },

    async GetAbuseReport(payload: IGetAbuseReport) {
      const { data, status } = await reportAPI.ReportServices.GetAbuseReport(payload)
      return status ? data : []
    },

    async GetAbuseReportExcel(payload: IGetAbuseReport) {
      await reportAPI.ReportServices.GetAbuseReportExcel(payload)
    },

    async GetEngagementReport(payload: IGetEngagementReport) {
      const { data, status } = await reportAPI.ReportServices.GetEngagementReport(payload)
      return status ? data : []
    },

    async GetEngagementReportExcel(payload: IGetEngagementReport) {
      await reportAPI.ReportServices.GetEngagementReportExcel(payload)
    },

    async GetCommentReport(payload: IGetCommentReport) {
      const { data, status } = await reportAPI.ReportServices.GetCommentReport(payload)
      return status ? data : []
    },

    async GetCommentReportExcel(payload: IGetCommentReport) {
      await reportAPI.ReportServices.GetCommentReportExcel(payload)
    },
  },
})
